import { HTMLProps } from "react";
import { Tooltip } from "react-migration/components/Tooltip";

import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { Button } from "react-migration/components/Button";
import { Icon } from "react-migration/components/Icon";

const QuickLinkWrapper = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col items-start" {...rest}>
      {children}
    </div>
  );
};

const QuickLinkLink = ({ children, onClick, feature }: HTMLProps<HTMLButtonElement> & { feature?: Feature }) => {
  return (
    <>
      {(!feature || hasFeature(feature)) && (
        <Button className="text-platform-600" variant="ghost" onClick={onClick}>
          {children}
        </Button>
      )}
      {feature && !hasFeature(feature) && (
        <Tooltip.Wrapper delayDuration={0}>
          <Tooltip.Trigger>
            <Button className="text-platform-600" variant="ghost" disabled={true}>
              {children} <Icon icon="lt-arrow-right-line" />
            </Button>
          </Tooltip.Trigger>
          <Tooltip.Content align="center" side="right" size="sm">
            Not available on your current plan
          </Tooltip.Content>
        </Tooltip.Wrapper>
      )}
    </>
  );
};

export const QuickLink = {
  Wrapper: QuickLinkWrapper,
  Link: QuickLinkLink,
};
